import React from "react";
import { SidePanel, SidePanelContent } from "../../../../../../common/components";
import PANELS from "./panels";
import { translate } from "../../../../../../common/providers";

export default function FormStudioSidePanels({
	row,
	onActive: onActiveFromParent = null,
	onClose,
	onUpdateRow,
	platformCompanies,
	open,
	panel,
	projectsRequest,
}) {
	return (
		<SidePanel open={open} size={65} onActive={onActiveFromParent} onClose={onClose}>
			{({ onActive }) => (
				<SidePanelContent
					title={panel && translate(PANELS[panel].title, { name: row?.name })}
					onActive={onActive}
					onClose={onClose}
				>
					{row && panel && PANELS[panel].panel({ row, projectsRequest, onUpdateRow, platformCompanies })}
				</SidePanelContent>
			)}
		</SidePanel>
	);
}
